/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTrendForecastWidgetConfiguration extends models.CostTrendWidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("CostTrendForecastWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostTrendForecastWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostTrendForecastWidgetConfiguration>): CostTrendForecastWidgetConfiguration {
        let obj = Object.assign(new CostTrendForecastWidgetConfiguration(), model);
        CostTrendForecastWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTrendForecastWidgetConfiguration>): CostTrendForecastWidgetConfiguration {
        if (!model) return null;
        return CostTrendForecastWidgetConfiguration.newInstance(<CostTrendForecastWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTrendForecastWidgetConfiguration) {
        if (!obj) return;

        models.CostTrendForecastWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTrendForecastWidgetConfiguration): boolean {
        if (models.CostTrendWidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostTrendForecastWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
